import { SupportFormData } from '../types/form';

// Resend Email Service Integration
// Sign up at https://resend.com for free API key (3,000 emails/month free)

// Helper function to convert file to base64
const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result as string;
      // Remove the data:type;base64, prefix
      const base64 = result.split(',')[1];
      resolve(base64);
    };
    reader.onerror = error => reject(error);
  });
};

// Resend Email Service via Vercel API
export const submitSupportForm = async (formData: SupportFormData): Promise<void> => {
  // Convert file to base64 if present
  let fileData = null;
  let fileName = null;
  let fileType = null;
  
  if (formData.file) {
    fileData = await convertFileToBase64(formData.file);
    fileName = formData.file.name;
    fileType = formData.file.type;
  }

  const response = await fetch('/api/send-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      name: formData.name,
      email: formData.email,
      paymentDate: formData.paymentDate,
      transactionAmount: formData.transactionAmount,
      message: formData.message,
      fileData,
      fileName,
      fileType
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to send support request');
  }
};

// Demo mode for development/testing
export const submitFormDemo = async (formData: SupportFormData): Promise<void> => {
  return new Promise((resolve) => {
    console.log('=== DEMO: SUPPORT FORM SUBMISSION ===');
    console.log('Name:', formData.name);
    console.log('Email:', formData.email);
    console.log('Payment Date:', formData.paymentDate);
    console.log('Transaction Amount:', formData.transactionAmount);
    console.log('Message:', formData.message);
    console.log('File:', formData.file ? `${formData.file.name} (${formData.file.size} bytes)` : 'None');
    console.log('=====================================');
    
    // Simulate network delay
    setTimeout(() => {
      resolve();
    }, 1500);
  });
};

// Switch between demo and production mode
// Set to true for demo mode, false for production
const USE_DEMO_MODE = false;

// Main export - automatically switches based on mode
export const sendSupportEmail = async (formData: SupportFormData): Promise<void> => {
  if (USE_DEMO_MODE) {
    return await submitFormDemo(formData);
  } else {
    return await submitSupportForm(formData);
  }
};